import React, { Component } from "react";
import { getProcessingAppData } from "../../api";
import barImage from "../../../images/bar-img.png";
import caretImg from "../../../images/caret.png";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { Link } from "react-router-dom";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import addDays from "date-fns/addDays";
import subDays from "date-fns/subDays";
import { subYears, startOfYear, endOfYear, subMonths } from "date-fns";
import SelectDropDown from "./drop-down";

class AppProcessing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            progressionData: [],
            timePeriodValue: "Last_7_Days",
            timePeriod: [],
            calenderValue: [],
            dropUserText: "",
            user: "",
        };
        this.element = React.createRef();
    }

    componentDidMount() {
        var date = new Date();
        let params = {
            firstDate: subDays(date, 6).toLocaleDateString("en-US"),
            lastDate: date.toLocaleDateString("en-US"),
            user: this.state.user,
        };
        this.setState({
            timePeriodValue: "Current_month",
            calenderValue: [params.firstDate, params.lastDate],
        });
        getProcessingAppData(params)
            .then((res) => {
                this.setState({
                    progressionData: res,
                });
            })
            .catch((err) => {});
    }

    handleProcessingAppDateChange(dates) {
        let params = {
            firstDate: dates[0].toLocaleDateString("en-US"),
            lastDate: dates[1].toLocaleDateString("en-US"),
            user: this.state.user,
        };
        this.setState({
            timePeriodValue: "Custom_date",
            calenderValue: [params.firstDate, params.lastDate],
        });

        getProcessingAppData(params)
            .then((res) => {
                this.setState({
                    progressionData: res,
                });
            })
            .catch((err) => {});
    }
    daysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };
    handlePeriodChange = (e) => {
        var date = new Date();
        let params = {};
        this.setState({
            timePeriodValue: e.target.value,
            calenderValue: [startOfDay(new Date()), endOfDay(new Date())],
        });

        if (e.target.value === "Last_7_Days") {
            params = {
                firstDate: subDays(date, 6).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Current_month") {
            params = {
                firstDate: new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    1,
                ).toLocaleDateString("en-US"),
                lastDate: new Date().toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Current_Year") {
            params = {
                firstDate: startOfYear(date).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Last_month") {
            params = {
                firstDate: new Date(
                    date.getFullYear(),
                    date.getMonth() - 1,
                    1,
                ).toLocaleDateString("en-US"),
                lastDate: new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    0,
                ).toLocaleDateString("en-US"),
            };
        } else if (e.target.value === "Last_3_Months") {
            params = {
                firstDate: subMonths(date, 3).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Last_6_Months") {
            params = {
                firstDate: subMonths(date, 6).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Previous_Year") {
            params = {
                firstDate: startOfYear(subYears(date, 1)).toLocaleDateString(
                    "en-US",
                ),
                lastDate: endOfYear(subYears(date, 1)).toLocaleDateString(
                    "en-US",
                ),
                user: this.state.user,
            };
        } else if (e.target.value === "All") {
            params = {
                firstDate: new Date("01/01/2000").toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
                user: this.state.user,
            };
        } else if (e.target.value === "Custom_date") {
            this.element.current.open();
            return;
        }

        getProcessingAppData(params)
            .then((res) => {
                this.setState({
                    progressionData: res,
                });
            })
            .catch((err) => {});
    };

    handelUserChange = (e) => {
        let value = e.value;
        if (value.split("-")[0] === "org") {
            this.setState({
                dropUserText: "Org",
                user: value,
            });
        } else {
            this.setState({
                dropUserText: "User",
                user: value,
            });
        }
        let params = {
            firstDate: this.state.calenderValue[0],
            lastDate: this.state.calenderValue[1],
            user: value,
        };
        this.props.updateDropUser(value);
        getProcessingAppData(params)
            .then((res) => {
                this.setState({
                    progressionData: res,
                });
            })
            .catch((err) => {});
    };

    render() {
        const { progressionData } = this.state;
        const colors = [
            "#819FEC",
            "#7FCECE",
            "#F0BE74",
            "#E7B8DF",
            "#44AE42",
            "#FFA500",
            "#C5C5C5",
        ];
        const timePeriod = [
            "Last_7_Days",
            "Current_month",
            "Current_Year",
            "Last_month",
            "Last_3_Months",
            "Last_6_Months",
            "Previous_Year",
            "All",
            "Custom_date",
        ];
        const { afterToday } = DateRangePicker;
        return (
            <div className="shadow-card">
                <div className="row app-process-row">
                    <div className="col-md-12 col">
                        <div className="d-flex">
                            <div className="d-flex align-items-center datePickerParentClass">
                                <div className="myDatePicker datepicker-range-app">
                                    <DateRangePicker
                                        ref={this.element}
                                        onChange={(value) => {
                                            this.handleProcessingAppDateChange(
                                                value,
                                            );
                                        }}
                                        onOk={(value) => {
                                            this.handleProcessingAppDateChange(
                                                value,
                                            );
                                        }}
                                        appearance="subtle"
                                        placeholder=""
                                        style={{ width: 28 }}
                                        disabledDate={afterToday()}
                                        cleanable={false}
                                        ranges={[
                                            {
                                                label: "Yesterday",
                                                value: [
                                                    addDays(new Date(), -1),
                                                    addDays(new Date(), -1),
                                                ],
                                            },
                                            {
                                                label: "Today",
                                                value: [new Date(), new Date()],
                                            },
                                            {
                                                label: "Last 7 days",
                                                value: [
                                                    subDays(new Date(), 6),
                                                    new Date(),
                                                ],
                                            },
                                        ]}
                                        placement="bottomEnd"
                                    />
                                </div>
                                <div className="period-btn">
                                    <span>Period</span>
                                    <select
                                        style={{
                                            backgroundImage: `url(${caretImg})`,
                                        }}
                                        onChange={(e) =>
                                            this.handlePeriodChange(e)
                                        }
                                    >
                                        {timePeriod.map((item, index) => (
                                            <option value={item} key={index}>
                                                {item.replace(/_/g, " ")}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {this.props.user.organization_id > 1 &&
                            this.props.user.role === "agent" ? null : (
                                <div className="d-flex align-items-center analytics-filtering">
                                    <div className="test-orglist metric-btnselect">
                                        <span>{this.state.dropUserText}</span>
                                        <SelectDropDown
                                            options={this.props.dropDownUsers}
                                            name="periodoptn"
                                            placeholder="Choose To Filter"
                                            value=""
                                            handleChange={(evt) =>
                                                this.handelUserChange(evt)
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <hr />
                <div className="app-process-dtl">
                    {progressionData.length > 0 &&
                        progressionData.map((data, index) => (
                            <div className="app-list" key={index}>
                                <span className="perc">{data.percent}</span>
                                <span className="label">
                                    {data.progression}
                                </span>
                                <span
                                    className="bar"
                                    style={{
                                        width: (data.percent / 100) * 57 + "%",
                                        backgroundImage: `linear-gradient(to right, white , ${colors[index]})`,
                                    }}
                                ></span>
                            </div>
                        ))}
                </div>
                <hr />
                <div className="see-app-list">
                    <Link to="/applications">See application list</Link>
                </div>
            </div>
        );
    }
}

export default AppProcessing;
